module.exports = __webpack_public_path__ + "static/media/Emer-bannerweb-1.1202ce77.png";